import FacebookService from 'services/facebook_service'

class FacebookCommentObserver
  observe: ->
    FacebookService.loadSdk().then((FB) =>
      FB.Event.subscribe('comment.create', @createComment)
      FB.Event.subscribe('comment.remove', @removeComment)
    )

  # response:
  # Object {href: "http://localhost:3000/fmu", commentID: "585544478212744", parentCommentID: undefined, message: "wewefewfwf"}
  createComment: (response)->
    commentEntryPoint = $('.fb-comments')
    observedId        = commentEntryPoint.data('observed-id')
    observedType      = commentEntryPoint.data('observed-type')

    $.ajax
      type: 'POST'
      url: '/facebook/tickets'
      data: {
        href:              response.href,
        observed_id:       observedId,
        observed_type:     observedType,
        comment_id:        response.commentID,
        parent_comment_id: response.parentCommentID,
        thread_id:         response.parentCommentID || response.commentID,
        message:           response.message
      }

  # response:
  # Object {href: "http://localhost:3000/fmu", commentID: "585544478212744"}
  removeComment: (response)->
    commentEntryPoint = $('.fb-comments')
    observedId        = commentEntryPoint.data('observed-id')
    observedType      = commentEntryPoint.data('observed-type')

    $.ajax
      type: 'DELETE'
      url: '/facebook/tickets/'
      data: {
        href:              response.href,
        observed_id:       observedId,
        observed_type:     observedType,
        comment_id:        response.commentID,
        parent_comment_id: response.parentCommentID,
        thread_id:         response.parentCommentID || response.commentID
      }

$(document).on 'facebook.rendered', ->
  (new FacebookCommentObserver).observe()

# Probably the page needs to load the sdk
FacebookService.loadSdk()
